// WARNING: translate is global function from outside JS!!!!

export default {
	install(Vue, options) {
		Vue.prototype.$i18nCustom = {
			translate(category, text, options = {}) {
				return translate(category, text, options);
			}
		}
	}
};
